export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/sharepoint/manage-site-collection-storage-limits#monitor-site-storage-limits-by-using-powershell';
